import { useEffect } from 'react'
import { AppContact } from '../components/AppContact'
import { StyledSubHeader } from '../components/StyledSubHeader'
import logo from '../eye-mask.svg'
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";

export const NeedForInvite = () => {

    useEffect(() => {
        document.title = 'Need for Invite'
    }, [])

    return (
        <motion.div className='absolute' style={{ height: '100%', width: '100%', overflow: 'scroll' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div className='flex-column about'  >
                <img src={logo} alt="" style={{ width: 100, height: 70, marginTop: 10 }} />
                <h2>Why do I need an Invite Code?</h2>
                <h4>The short answer</h4>
                <p>To establish trust and verify yourself.</p>
                <h4>The long answer</h4>
                <p>SayToMe is a private platform which translates to a community of real,
                    genuine users who have either verified themselves to SayToMe or its users.</p>
                <p>Hence, to help the platform continue to be trusted, we need you to verify youself and establish trust.</p>
                <i>Invite codes are tokens of trust</i>
                <StyledSubHeader heading="What if I don't choose to verify?" />
                <p>The simplest and only answer to this is</p>
                <p style={{ fontStyle: 'italic' }} >You don't get in. Period</p>
                <StyledSubHeader heading="How do I get an Invite Code?" />
                <p>Glad you asked :). Essentially there are only two ways to get an invite code as follows:</p>
                <ol>
                    <li>You ask an invite code from a friend who is already a SayToMe member.</li>
                    <p>SayToMe trusts is users and also the users its users trust.</p>
                    <li>Don't have a friend who is a member yet? Ask us</li>
                    <p>You can ask SayToMe directly for an invite code after verifying yourself. Dm us on Instagram or LinkedIn.</p>
                </ol>
                <p>Your invite code will be tied to your Instagram or LinkedIn profile you provide, no matter which of the above ways you choose.</p>
                <div>
                    <StyledSubHeader heading="How does SayToMe establish trust?" />
                    <p>SayToMe believes that Photo verification with weird poses cannot establish trust nor could a video recording. Why?</p>
                    <p>There have been various instances where tricksters have used ML and AI(read as Machine Learning and Artificial inteligence ) to forge
                        and trick Verification systems to pass through and spread hate and abuse. Yes you read it right, there are verification systems rather then
                        real people who again use ML and AI to verify you. We SAY NO to DUMB verification systems. Rather we use real people including you to
                        to help us verify our real users and establish trust.
                    </p>
                    <p>How is it done?</p>
                    <p>Through following steps :</p>
                    <ol>
                        <li>You initiate a request to join SayToMe by direct messaging us either on Instagram or LinkedIn.</li>
                        <li>We verify your Instagram or LinkedIn profile. If not satisfied, we request a video call verification.</li>
                        <li>After verification is successful, you are issued an invite code tied to your Instagram or LinkedIn profile
                            which essentially means your Instagram or LinkedIn id can show up on your SayToMe profile and you can't change it.
                        </li>
                        Additionally, you're shown a video verified badge on your SayToMe profile if you're video call verified.
                    </ol>
                    <p>And that's it, Trust is established and you're most welcome to the trusted community :)</p>
                    <p>To Err is Human and so is for us. Despite our best efforts, there could be creeps creeping into our community.
                        Feel free to report them to SayToMe and appropriate action will be taken.
                    </p>
                </div>
                <AppContact />
                <img src={logo} alt="" style={{ width: 40, height: 30, marginTop: 10 }} />
            </div>
        </motion.div>
    )
}